import React from 'react'

const EngineeringTheAscent = () => {
    return (
        <div className="bg-[#00101D] w-full py-16 px-4 md:px-8 lg:px-16 overflow-hidden">
            {/* Section Title */}
            <div className="container mx-auto">
                <h2 className="text-3xl md:text-6xl  text-white text-center font-light md:font-medium">
                    Engineering the <span className="text-background-blue font-medium md:font-bold italic">Ascent</span>
                </h2>
            </div>

            {/* Content Flex Container */}
            <div className="rounded-[1rem] mt-4 md:mt-10 container mx-auto flex items-center flex-col gap-8 lg:gap-16 md:flex-row py-8 lg:py-16 px-4 lg:px-16"
                style={{ background: 'radial-gradient(66.61% 100% at 50% 100%, #001D35 0%, #000C16 100%)' }}>
                {/* Left Column - Payment Platform Image */}
                <div className="w-56 lg:w-64">
                    <img
                        src="/assets/multi-platform-payment.png"
                        alt="Multi Platform Payment Experience"
                        className="w-full h-auto object-cover"
                    />
                </div>

                {/* Right Column - Text Content */}
                <div className="md:w-2/3 space-y-8 text-white">
                    <p className="text-sm md:text-xl">
                        Led by Alexander Bowden, Everest Apps is an Australian software company built on honesty, innovation, and results. With expert full stack developers, consultants, senior-level advisors internationally and we scale ideas into high-performance apps.
                    </p>

                    <p className="text-sm md:text-xl">
                        In the past year alone, we've launched 4 live apps, partnered with thousands of schools, delivered AI-driven tech for Ibiza, and built custom web platforms for creators, combining fan subscriptions and live chat to local services.
                    </p>

                    <p className="text-background-blue text-xl md:text-2xl font-semibold">
                        If you're ready for direct, expert support and future-facing solutions. Let's build together.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default EngineeringTheAscent